var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ModalCookies'),_c('Loader'),_c('HomePageSection1'),_c('HomePageSection2'),_c('HomePageSection3'),_c('HomePageSection4'),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }